import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        title: {
            flexGrow: 1,
            fontSize: '22px',
            fontWeight: '500',
            marginTop: 3,
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '20px',
            minHeight: '40px'
        },
        hide: {
            visibility: 'hidden',
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
            '&.flex-j-e': {
                justifyContent: 'end',
            },
        },
        section: {
            marginBottom: '32px',
        },
        clean: {
            fontSize: '2.4rem',
            color: colors.color4,
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        containerButtons: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingBottom: 1,
            marginTop: 1,
            marginBottom: 1
        },
        cancelButton: {
            '&.MuiButton-root': {
                padding: '0px'
            }
        },
    }
}

export { useStyles }
